<template>
  <a
    class="share-button facebook-share-button"
    :href="shareUrl"
    target="_blank"
    @click="firePropTrackAction()"
  >
    <img src="@/assets/images/share-facebook.svg" />
    <span>Facebook</span>
  </a>
</template>

<script>
export default {
  computed: {
    shareUrl() {
      const url = encodeURIComponent("https://topjobs.xing.com/");
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    },
  },
  methods: {
    firePropTrackAction() {
      const trackingParams = {
        PropTrackAction: "jobs_topjobs_social_share",
        PropActionOrigin: "jobs_topjobs_social_share_facebook",
      };
      window.ttt.event("PropTrackAction", trackingParams);
      console.log("propTrackAction", trackingParams);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/share-button.scss";
</style>
